import React, { Component } from "react";
import styled from "styled-components";
import { debounce, trim, upperCase } from "lodash";
import { Navigate } from "react-router";
// assets
import deleteico from "assets/images/deleteico.png";
import eye from "assets/images/eye.png";
import group from "assets/images/group-2.png";
import insurance from "assets/svgs/insurance.svg";
import DownloadIcon from "assets/images/downloadcsv.png";
import AddIcon from "assets/svgs/add.svg";
import patient from "assets/images/patient.png";
import renewalprice from "assets/images/priceUp.png";
import EmployeeIcon from "assets/svgs/employee.svg";
import MembersIcon from "assets/svgs/members.svg";
import icicLombart from "assets/images/iciciLombard.png";
import FilterIcon from "assets/svgs/filter.svg";
// components
import {
  Ptag,
  LargeButton,
  Icons,
  LoaderDots,
  Chip,
  OverlayLoader,
  BaseTable,
} from "components/core";
import PaymentPopup from "components/core/paymentBreakup";
import "components/core/style.css";

import http from "services/httpService";
import {
  findInValues,
  toTitleCase,
  formatAmount,
  formatDateYYYY,
  isFlexFlow,
  isGmcFlow,
  healthIssuancePresent,
  showCorporateBuffer,
  dependentsFormation,
  opdPresent,
} from "utlis/utils";

import { Pdf } from "constants/businessConstant";
import {
  Divider,
  DownloadLink,
  InsuranceCardsWrapper,
  SplitWrapper,
  StickyCell,
  Table,
  TableWrapper,
  TopHeader,
  FlexProductList,
  IndividualList,
} from "./styles";
import InsurancePlanCard from "components/Dashboard/InsurancePlanCard";
import BenefitCardList from "components/Dashboard/BenefitCardList";
import { startCase } from "lodash";
import SplitDetailCard from "components/Dashboard/SplitDetailCard";
import { theme } from "theme";
import { FLEX_PRODUCTS } from "constants";
import { PRIORITY_ORDER } from "constants";
import { HomeWrapper } from "components/CdBalance/style";

class CaredashboardList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gmcMisData: [],
      employeeData: null,
      companyLoader: true,
      employeeLoader: true,
      showDeletePopUp: false,
      policies: [],
      error: { loader: true },
      overallsummary: [],
      cardArray: [],
      showPayment: false,
      sboType: "",
      insurerName: "",
      showFilterArray: [],
      isPaymentDone: false,
      company_name: "",
      arrForSearch: [],
      myCsvRef: React.createRef(),
      filterText: "Filter",
      showAnnualGmcFields: false,
      tableData: [],
      products: [],
      navigateToPreviewEmployeeId: false,
      flexMisData: [],
      flexCurrentProductTableData: [],
      flexCurrentProductName: "",
      token: -1,
      healthInsuranceDescription: "",
      opdDescription: "",
      uhidExists: true,
    };
    this.renderDesireProductTable = this.renderDesireProductTable.bind(this);
  }

  componentDidMount = async () => {
    sessionStorage.clear();
    if (isFlexFlow()) {
      // await this.getFlexCompanyData();
      await this.getFlexProductDetail();
      // await this.getCurrentTasks();
    } else if (isGmcFlow()) {
      await this.getGmcCompanyData();
      await this.getEmployeesData();
    } else {
      try {
        const companyPromise = this.getCompanyData();
        const employeesPromise = this.getEmployeesData();
      } catch (ex) {}
    }
    this.setState({
      companyLoader: false,
    });
  };

  getCurrentTasks = async () => {
    const { data } = await http.get("/business/get_all_tasksets/");

    console.log({ data });
  };

  getFlexProductDetail = async () => {
    const { data } = await http.get("/business/get_company_product_details/");
    const companyName = data.company_name;
    this.props.setCompanyName(companyName);
    const cta_data = {
      uhid_exists: data?.uhid_exists,
      cut_off_date_passed: data?.cut_off_date_passed,
      dc_collection: data?.dc_collection,
      dc_taskset_id: data?.dc_taskset_id,
      collection_allowed: data?.collection_allowed,
    };
    this.setState({ uhidExists: data?.uhid_exists });
    this.props?.dashboardCta(cta_data);
    localStorage.setItem("test", JSON.stringify(data));
    let sortedArray = Object.entries(data.product_details).sort(
      ([currentKey, currentValue], [nextKey, nextValue]) => {
        const currentBoolean = currentValue.userplan_data.mandatory;
        const nextBoolean = nextValue.userplan_data.mandatory;
        if (currentBoolean && !nextBoolean) {
          return -1;
        } else if (!currentBoolean && nextBoolean) {
          return 1;
        } else {
          const currentPriority = PRIORITY_ORDER.indexOf(currentKey);
          const nextPriority = PRIORITY_ORDER.indexOf(nextKey);

          if (currentPriority !== -1 && nextPriority !== -1) {
            return currentPriority - nextPriority;
          } else if (currentPriority !== -1) {
            return -1;
          } else if (nextPriority !== -1) {
            return 1;
          } else {
            return currentKey.localeCompare(nextKey);
          }
        }
      }
    );
    let gmcDetails = Object.keys(Object.fromEntries(sortedArray)).reduce(
      (acc, key) => {
        acc[key] = Object.fromEntries(sortedArray)[key]["userplan_data"];
        return acc;
      },
      {}
    );
    const comp = Object.fromEntries(sortedArray);
    const flex_userplan_ids = Object.keys(comp).reduce((acc, key) => {
      acc[key] = comp[key].userplan;
      return acc;
    }, {});
    localStorage.setItem(
      "flex_userplan_ids",
      JSON.stringify(flex_userplan_ids)
    );
    this.setState({ gmcMisData: Object.fromEntries(sortedArray) });
    localStorage.setItem(
      "flex_products_list",
      JSON.stringify(Object.keys(gmcDetails))
    );
    const buffer = healthIssuancePresent(gmcDetails) ? true : false;
    const opd = opdPresent(gmcDetails) ? true : false;
    if (opd) {
      const description_opd =
        data?.product_details["opd_cover"]?.dependents_allowed_union;
      let opd_result = "";
      opd_result =
        "Out patient cover for " + dependentsFormation(description_opd);
      this.setState({ opdDescription: opd_result });
    }
    localStorage.setItem("show_claim_summary", data?.show_claim_summary)
    this.props.showClaims(data?.show_claim_summary)
    if (buffer) {
      const buffer_boolean =
        data?.product_details["health_insurance"]?.is_corporatebuffer;
      this.props.showBuffer(buffer_boolean);
      var descriptionData =
        data?.product_details["health_insurance"]?.dependents_allowed_union;
      let result = "";
      result = "Medical cover for " + dependentsFormation(descriptionData);
      this.setState({ healthInsuranceDescription: result });

      localStorage.setItem("show_buffer_data", buffer_boolean);
    } else {
      this.props.showBuffer(false);
    }

    localStorage.setItem("gmc_details", JSON.stringify(gmcDetails));
  };

  sortProducts = (products) => {
    return products.sort(([p1Name], [p2Name]) => {
      if (p1Name > p2Name) return 1;
      if (p1Name < p2Name) return -1;
      return 0;
    });
  };

  getFlexCompanyData = async () => {
    let { data } = await http.get(
      "business/get_employee_detail_for_group_products/"
    );

    const sortedArray = Object.entries(data[0]).sort(
      ([currentKey, currentValue], [nextKey, nextValue]) => {
        const currentBoolan =
          currentValue.overallsummary.userplan_data.mandatory;
        const nextBoolean = nextValue.overallsummary.userplan_data.mandatory;
        if (currentBoolan && !nextBoolean) {
          return -1;
        } else if (!currentBoolan && nextBoolean) {
          return 1;
        } else {
          const currentPriority = PRIORITY_ORDER.indexOf(currentKey);
          const nextPriority = PRIORITY_ORDER.indexOf(nextKey);

          if (currentPriority !== -1 && nextPriority !== -1) {
            return currentPriority - nextPriority;
          } else if (currentPriority !== -1) {
            return -1;
          } else if (nextPriority !== -1) {
            return 1;
          } else {
            return currentKey.localeCompare(nextKey);
          }
        }
      }
    );

    data[0] = Object.fromEntries(sortedArray);
    const firstKey = Object.keys(data[0])[0];
    // const companyName = data[0][firstKey].overallsummary.company_name;
    // this.props.setCompanyName(companyName)
    const products = [];
    if (data["GMC"]) products.push("GMC");
    if (data["GMC_M"]) products.push("GMC_M");
    if (data["GPA"]) products.push("GPA");
    if (data["GTL"]) products.push("GTL");
    this.updateFilters(
      Object.entries(data[0])[0][1].employees_data,
      null,
      true
    );
    console.log({ firstKey });
    this.setState({
      gmcMisData: data[0],
      flexMisData: data[0],
      flexCurrentProductTableData: Object.entries(data[0])[0][1],
      flexCurrentProductName: Object.entries(data[0])[0][0],
      employeeLoader: false,
      employeeData: data,
      arrForSearch: Object.entries(data[0])[0][1],
      products,
    });
    let gmcDetails = Object.keys(data[0]).reduce((acc, key) => {
      acc[key] = data[0][key]["overallsummary"]["userplan_data"];
      return acc;
    }, {});
    localStorage.setItem(
      "flex_products_list",
      JSON.stringify(Object.keys(gmcDetails))
    );
    localStorage.setItem("gmc_details", JSON.stringify(gmcDetails));
  };

  getGmcCompanyData = async () => {
    let { data } = await http.get("business/business_user_mis_data/");
    const sortedArray = Object.entries(data).sort(
      ([currentKey, value], [nextKey, value2]) => {
        return currentKey.localeCompare(nextKey);
      }
    );
    data = Object.fromEntries(sortedArray);
    localStorage.setItem("gmc_details", JSON.stringify(data));
    const firstKey = Object.keys(data)[0];
    const sbo_type = data[firstKey].sbo_type;
    this.setState({
      gmcMisData: data,
      sboType: sbo_type,
    });
    const gmcFlowKeys = ["GMC", "GMC_M", "GPA", "GTL"];
    if (gmcFlowKeys.includes(sbo_type)) {
      this.setState({ showAnnualGmcFields: true });
    }
  };

  getCompanyData = async () => {
    const userplan_id =
      localStorage.getItem("userplan_id") ||
      sessionStorage.getItem("userplan_id");
    try {
      const { data } = await http.get(`/business/userplans/${userplan_id}/`);
      if (!data["is_payment_done"]) {
        localStorage.setItem("isPlanEditable", true);
      } else {
        localStorage.removeItem("isPlanEditable");
      }
      this.props.setPlanEditable(!data["is_payment_done"]);
      this.props?.setCompanyName(data["company_name"]);
      this.setState({
        company_name: data["company_name"],
        cardArray: data["plan_benefits"] || [],
        sboType: data["sbo_type"],
        insurerName: data["service_provider"],
        isPaymentDone: data["is_payment_done"],
        policy_doc_url: data["policy_doc_url"],
        sum_insured_gpa: data["sum_insured_gpa"],
        next_billing_date:
          data["subscription"] && data["subscription"]["next_billing_date"],
      });

      const employeeEditPermissions = {
        notification:
          (data["add_employee_button_info"] &&
            data["add_employee_button_info"]["notification"]) ||
          "",
        showPopUp:
          (data["add_employee_button_info"] &&
            data["add_employee_button_info"]["add_employee_off"]) ||
          false,
      };
      localStorage.setItem(
        "service_provider",
        data["service_provider"]["name"]
      );
      localStorage.setItem("company_name", this.state.company_name);
      data &&
        data["policy_doc_url"] &&
        localStorage.setItem("policy_doc_url", data["policy_doc_url"]);
      localStorage.setItem(
        "employeeEditPermissions",
        JSON.stringify(employeeEditPermissions)
      );
      if (this.state.sboType === "GMC" || this.state.sboType === "GMC_M") {
        this.setState({ showAnnualGmcFields: true });
      }
    } catch (error) {
      console.log(error);
      throw new Error("Error fetching company data");
    }
  };

  getEmployeesData = async () => {
    this.setState({ employeeLoader: true });
    try {
      const { data } = await http.get(`/business/employee_detail/`, {
        params: {
          userplan_id:
            localStorage.getItem("userplan_id") ||
            sessionStorage.getItem("userplan_id"),
        },
      });
      if (isGmcFlow()) {
        const firstKey = Object.keys(data)[0];
        const companyName = data[firstKey].overallsummary.company_name;
        this.props.setCompanyName(companyName);
        const tableInfo = this.generateTableData(data);
        const products = [];
        if (data["GMC"]) products.push("GMC");
        if (data["GMC_M"]) products.push("GMC_M");
        if (data["GPA"]) products.push("GPA");
        if (data["GTL"]) products.push("GTL");

        this.updateFilters(tableInfo, products);

        this.setState({
          employeeLoader: false,
          employeeData: data,
          tableData: tableInfo,
          arrForSearch: tableInfo,
          products,
        });
      } else {
        const companyName = data.overallsummary.company_name;
        this.props.setCompanyName(companyName);
        let table_data = [];
        table_data = [...table_data, ...data["employees_data"]];
        const unique = [
          ...new Set(data["employees_data"].map((item) => item.policy_status)),
        ];

        this.setState({
          policies: table_data,
          arrForSearch: table_data,
          showFilterArray: unique,
          due_date: data["overallsummary"]["due_date"],
        });
        localStorage.setItem("emp_data", JSON.stringify(data));
        this.setState({
          overallsummary: data && data.overallsummary,
          employeeLoader: false,
        });
      }
    } catch (error) {
      console.error(error);
      throw new Error("Error fetching employees data");
    }
  };

  getIndividualStatusNames = (type, status) => {
    if (!type) {
      switch (status) {
        case "ACTIVATION PENDING":
          return "Pending";
        case "ACTIVATED":
          return `Activated`;
        case "DELETION INITIATED":
          return `Deletion Initiated`;
        case "STOPPED":
          return `Stopped`;
        default:
          return "";
      }
    }
    if (status === "ACTIVATION PENDING") {
      return `${type} Pending`;
    }
    return `${type} ${startCase(status.toLowerCase())}`;
  };

  updateFilters = (tableData, products, isFlex) => {
    let reducer;
    if (isFlex) {
      reducer = (acc, employee) => {
        let newArr = acc;
        if (employee.policy_status) {
          newArr = [
            ...new Set(newArr).add(
              this.getIndividualStatusNames(null, employee.policy_status)
            ),
          ];
        }

        return newArr;
      };
    } else {
      reducer = (acc, employee) => {
        let newArr = acc;
        if (employee["GMC"] && employee["GMC"].policy_status) {
          newArr = [
            ...new Set(newArr).add(
              this.getIndividualStatusNames(
                "GHI",
                employee["GMC"].policy_status
              )
            ),
          ];
        }
        if (employee["GMC_M"] && employee["GMC_M"].policy_status) {
          newArr = [
            ...new Set(newArr).add(
              this.getIndividualStatusNames(
                "GHI",
                employee["GMC_M"].policy_status
              )
            ),
          ];
        }
        if (employee["GPA"] && employee["GPA"].policy_status) {
          newArr = [
            ...new Set(newArr).add(
              this.getIndividualStatusNames(
                "GPA",
                employee["GPA"].policy_status
              )
            ),
          ];
        }
        if (employee["GTL"] && employee["GTL"].policy_status) {
          newArr = [
            ...new Set(newArr).add(
              this.getIndividualStatusNames(
                "GTL",
                employee["GTL"].policy_status
              )
            ),
          ];
        }
        return newArr;
      };
    }
    const options = tableData.reduce(reducer, []);
    this.setState({ showFilterArray: options });
  };

  onClickDeletePopUp = () => {
    this.setState({ showDeletePopUp: true });
  };

  onDeleteNoSelected = () => {
    this.setState({ showDeletePopUp: false });
  };

  onSelectPolicyItem = (index) => {
    const { policies } = this.state;
    policies[index]["isChecked"] = !policies[index]["isChecked"];
    this.setState({ policies: [...policies] });
  };

  areAllPoliciesSelected = () => {
    const { policies } = this.state;
    if (!policies || !policies.length) {
      return false;
    }
    return policies.every(
      (policy) => policy["policy_status"] === "STOPPED" || !!policy["isChecked"]
    );
  };

  selectAllPolicies = () => {
    const { policies } = this.state;
    const allSelected = this.areAllPoliciesSelected();
    policies.forEach((policy) => {
      policy["isChecked"] =
        policy["policy_status"] === "STOPPED" ? false : !allSelected;
    });
    this.setState({ policies: [...policies] });
  };

  onClickDelete = async () => {
    this.setState({
      loading: true,
    });
    let a = [];
    let listCheckedemployee = [];
    for (let i = 0; i < this.state.policies.length; i++) {
      if (this.state.policies[i].isChecked == true) {
        a.push(String(this.state.policies[i].employee_id));
        listCheckedemployee.push(i);
      }
    }
    try {
      const { data } = await http.delete(`business/employees1/`, {
        data: {
          id: a,
          userplan_id: localStorage.getItem("userplan_id"),
        },
      });
      await this.getEmployeesData();
      this.setState({ showDeletePopUp: false });
    } catch (e) {
      for (let i in listCheckedemployee) {
        this.state.policies[listCheckedemployee[i]]["isChecked"] = false;
      }
      this.setState({ showDeletePopUp: false });
      alert(e.response["data"]);
    }
  };

  cashLessClaim = () => {
    const sboType = this.state.sboType && this.state.sboType.toUpperCase();
    const insurerName =
      this.state.insurerName && this.state.insurerName.toUpperCase();
    if (sboType === "GMC") {
      if (insurerName.indexOf("NIVA") > -1) {
        window.open(
          "https://transaction.nivabupa.com/Pages/hospitalnetwork.aspx"
        );
      } else if (insurerName.indexOf("KOTAK") > -1) {
        window.open(
          "https://www.kotakgeneral.com/Externalfiles/Mediassit-hospital-list-03-04-2023.xlsb"
        );
      } else if (insurerName.indexOf("ICICI") > -1) {
        window.open("https://www.icicilombard.com/cashless-hospitals");
      } else {
        window.open(
          "https://www.careinsurance.com/health-plan-network-hospitals.html"
        );
      }
    } else if (sboType.indexOf("KOTAK") > -1) {
      window.open(
        "https://www.kotakgeneral.com/Externalfiles/Mediassit-hospital-list-03-04-2023.xlsb"
      );
    } else if (sboType.indexOf("DIGIT") > -1) {
      window.open("https://www.medibuddy.in/networkHospitals");
    } else {
      window.open(
        "https://www.careinsurance.com/health-plan-network-hospitals.html"
      );
    }
  };

  getPDFURL = () => {
    if (
      this.state.sboType === "GMC" ||
      this.state.sboType === "GMC_M" ||
      localStorage.getItem("insurer") === "go_digit"
    ) {
      if (this.state.policy_doc_url) {
        return this.state.policy_doc_url;
      } else {
        return null;
      }
    } else {
      return Pdf[upperCase(this.state.sboType)];
    }
  };

  goToPlanPdf = () => {
    const pdfURL = this.getPDFURL();
    if (pdfURL) {
      window.open(pdfURL);
    }
  };

  openIciciLombartPDF = () => {
    window.open(
      "https://images.getvital.in/Marketing/Group+Accident+Cover+Policy+Document.pdf",
      "_blank"
    );
  };

  openPaymentPopup = () => {
    this.setState({ showPayment: true });
  };

  handleCallback = (childData) => {
    this.setState({ showPayment: childData });
  };

  insuranceCardJsx = (type, details, index) => {
    let flexCard = isFlexFlow() && details.userplan_data;
    let JSX = "";
    switch (type) {
      case "GMC":
        JSX = (
          <InsurancePlanCard
            index={index}
            type="GMC"
            plan_detail={{
              title: "Group Mediclaim Cover",
              description: this.state.healthInsuranceDescription,
            }}
            details={details}
          />
        );
        break;
      case "GMC_M":
        JSX = (
          <InsurancePlanCard
            index={index}
            type="GMC"
            plan_detail={{
              title: "Group Mediclaim Cover",
              description: this.state.healthInsuranceDescription,
            }}
            details={details}
          />
        );
        break;
      case "GPA":
        JSX = (
          <InsurancePlanCard
            index={index}
            type="GPA"
            plan_detail={{
              title: "Group Personal Accident",
              description:
                "Coverage for accidental death or permanent disablement",
            }}
            details={details}
          />
        );
        break;
      case "GTL":
        JSX = (
          <InsurancePlanCard
            index={index}
            type="GTL"
            plan_detail={{
              title: "Group Term Life",
              description: "For financial protection against loss of life",
            }}
            details={details}
          />
        );
        break;
      case "health_insurance":
        JSX = (
          <InsurancePlanCard
            index={index}
            type="GMC"
            plan_detail={{
              title: "Group Mediclaim Cover",
              description: this.state.healthInsuranceDescription,
            }}
            details={flexCard}
          />
        );
        break;
      case "personal_accident":
        JSX = (
          <InsurancePlanCard
            index={index}
            type="GPA"
            plan_detail={{
              title: "Group Personal Accident",
              description:
                "Coverage for accidental death or permanent disablement",
            }}
            details={flexCard}
          />
        );
        break;
      case "term_life":
        JSX = (
          <InsurancePlanCard
            index={index}
            type="GTL"
            plan_detail={{
              title: "Group Term Life",
              description: "For financial protection against loss of life",
            }}
            details={flexCard}
          />
        );
        break;
      case "mandatory_top_up_health":
        JSX = (
          <InsurancePlanCard
            type="OPD"
            plan_detail={{
              title: "Mandatory Top Up Health",
              description: "For hospitalizations and day care treatments",
            }}
            details={flexCard}
          />
        );
        break;
      case "top_up_health":
        JSX = (
          <InsurancePlanCard
            type="top_up_health"
            plan_detail={{
              title: "Group Top Up Health",
              description:
                "Total amount of medical expenses which will be covered as per the policy terms after the base cover is exhausted",
            }}
            details={flexCard}
          />
        );
        break;
      case "opd_cover":
        JSX = (
          <InsurancePlanCard
            index={index}
            type="OPD"
            plan_detail={{
              title: "OPD Cover",
              description: this.state.opdDescription,
            }}
            details={flexCard}
          />
        );
        break;
      case "critical_illness":
        JSX = (
          <InsurancePlanCard
            index={index}
            type="CI"
            plan_detail={{
              title: "Critical Illness",
              description: "For financial protection against loss of life",
            }}
            details={flexCard}
          />
        );
        break;
      case "health_checkup":
        JSX = (
          <InsurancePlanCard
            index={index}
            type="HC"
            plan_detail={{
              title: "Health Checkup",
              description: "For financial protection against loss of life",
            }}
            details={flexCard}
          />
        );
        break;
      case "parental_cover":
        JSX = (
          <InsurancePlanCard
            index={index}
            type="parental_cover"
            plan_detail={{
              title: "Group Parental Cover",
              description: "Medical cover for Parents and In-laws",
            }}
            details={flexCard}
          />
        );
        break;
      case "health_insurance_parents":
        JSX = (
          <InsurancePlanCard
            index={index}
            type="health_insurance_parents"
            plan_detail={{
              title: "Group Mediclaim Cover (Parents)",
              description: "Medical cover for Parents",
            }}
            details={flexCard}
          />
        );
        break;
      case "health_insurance_parents_in_laws":
        JSX = (
          <InsurancePlanCard
            index={index}
            type="health_insurance_parents_in_laws"
            plan_detail={{
              title: "Group Mediclaim Cover (Parents-In-Laws)",
              description: "Medical cover for In-laws",
            }}
            details={flexCard}
          />
        );
        break;
    }
    return JSX;
  };

  renderInsuranceProducts = () => {
    // const products = Object.keys(this.state.gmcMisData).sort((a, b) => {
    //     if (a.slice(0, 3) < b.slice(0, 3)) {
    //       return -1;
    //     } else if (a.slice(0, 3) > b.slice(0, 3)) {
    //       return 1;
    //     } else {
    //       return a.length < b.length ? -1 : 1;
    //     }
    //   });
    const products = Object.keys(this.state.gmcMisData);
    return (
      <InsuranceCardsWrapper>
        {products.map((key, index) =>
          this.insuranceCardJsx(key, this.state.gmcMisData[key], index)
        )}
      </InsuranceCardsWrapper>
    );
  };

  renderBenefits = () => {
    const benefitsPol = Object.keys(this.state.gmcMisData).find(
      (k) => this.state.gmcMisData[k].plan_benefits.length > 0
    );
    if (!benefitsPol) return null;
    return (
      <BenefitCardList
        benefits={this.state.gmcMisData[benefitsPol].plan_benefits}
      />
    );
  };

  renderCard = () => {
    const { sum_insured_gpa } = this.state;
    if (isFlexFlow()) {
      return <>{this.renderInsuranceProducts()}</>;
    } else if (isGmcFlow()) {
      return (
        <>
          {this.renderInsuranceProducts()}
          {this.renderBenefits()}
          {this.state.cardArray.length > 0 && (
            <BenefitCardList benefits={this.state.cardArray} />
          )}
        </>
      );
    } else {
      return (
        <>
          <PlanSummaryBox>
            <SummaryBox style={{ padding: "18px 18px 18px 18px" }}>
              <PlanSummaryInnerDiv>
                <img src={insurance} width="36px" />
                <PlanSummaryNumberDiv>
                  <Ptag
                    fontSize="16px"
                    fontWeight="600"
                    color="#436AB2"
                    letterSpacing="0.57px"
                    lineHeight="24px"
                  >
                    Insurance
                  </Ptag>
                  <Ptag
                    fontSize="14px"
                    marginTop="5px"
                    letterSpacing="0.34px"
                    lineHeight="24px"
                    fontWeight="normal"
                  >
                    For hospitalizations and day care treatments
                  </Ptag>
                </PlanSummaryNumberDiv>
              </PlanSummaryInnerDiv>
              <Cashless>
                {this.getPDFURL() && (
                  <Links onClick={this.goToPlanPdf}>
                    <Ptag fontSize="14px" fontWeight="600" color="#4A90E2">
                      Policy Document
                    </Ptag>
                    <img
                      src={group}
                      width="14px"
                      height="14px"
                      style={{ marginLeft: 4, marginTop: 3 }}
                    />
                  </Links>
                )}

                <Links onClick={this.cashLessClaim}>
                  <Ptag fontSize="14px" fontWeight="600" color="#4A90E2">
                    Cashless Network
                  </Ptag>
                  <img
                    src={group}
                    width="14px"
                    height="14px"
                    style={{ marginLeft: 4, marginTop: 3 }}
                  />
                </Links>
              </Cashless>
            </SummaryBox>
            {Array.isArray(this.state.cardArray) &&
              this.state.cardArray.map((card, index) => (
                <SummaryBox
                  style={{ padding: "18px 18px 18px 18px" }}
                  key={index}
                >
                  <PlanSummaryInnerDiv>
                    <img src={card.icon_url} width="36px" />
                    <PlanSummaryNumberDiv>
                      <Ptag
                        fontSize="16px"
                        fontWeight="600"
                        color="#436AB2"
                        letterSpacing="0.57px"
                        lineHeight="24px"
                      >
                        {card.heading}
                      </Ptag>
                      <Ptag
                        fontSize="14px"
                        marginTop="5px"
                        letterSpacing="0.34px"
                        lineHeight="24px"
                        fontWeight="normal"
                      >
                        {card.employer_sub_heading}
                      </Ptag>
                    </PlanSummaryNumberDiv>
                  </PlanSummaryInnerDiv>
                </SummaryBox>
              ))}
            {!!sum_insured_gpa && (
              <SummaryBox style={{ padding: "18px 18px 18px 18px" }}>
                <CardHeader>
                  <PlanSummaryInnerDiv>
                    <img src={patient} width="36px" />
                    <PlanSummaryNumberDiv>
                      <Ptag
                        fontSize="16px"
                        fontWeight="600"
                        maxwidth="188px"
                        color="#436AB2"
                        letterSpacing="0.57px"
                        lineHeight="24px"
                      >
                        {"Personal Accident Cover"}
                      </Ptag>
                    </PlanSummaryNumberDiv>
                  </PlanSummaryInnerDiv>
                  <CardHeaderRight>
                    <Ptag fontSize="8px" letterSpacing="0.5px" color="#95979D">
                      {"POWERED BY"}
                    </Ptag>
                    <img src={icicLombart} height="18px" width="88px" />
                  </CardHeaderRight>
                </CardHeader>
                <Ptag
                  fontSize="14px"
                  marginTop="-22px"
                  marginBottom="4px"
                  marginLeft="42px"
                  letterSpacing="0.34px"
                  lineHeight="24px"
                  fontWeight="normal"
                >
                  {"Coverage for accidental death or permanent disablment"}
                </Ptag>
                <Links
                  style={{ justifyContent: "flex-end" }}
                  onClick={this.openIciciLombartPDF}
                >
                  <Ptag fontSize="14px" fontWeight="600" color="#4A90E2">
                    Policy Document
                  </Ptag>
                  <img
                    src={group}
                    width="14px"
                    height="14px"
                    style={{ marginLeft: 4, marginTop: 3 }}
                  />
                </Links>
              </SummaryBox>
            )}
          </PlanSummaryBox>
          {/* <CareEmployeesBox>
                <TotalEmployees>
                <InnerDiv>
                    <img src={totlemp} width="50px" style={{ marginBottom: 35 }} />
                    <NumberDiv>
                    <Ptag fontSize="22px" fontWeight="600" lineHeight="30px" letterSpacing="0.6px" color="#4A4A4A">Active Employees</Ptag>
                    <Ptag fontSize="36px" fontWeight="600" color="#4A4A4A" lineHeight="49px" letterSpacing="1px" >{(props.data.totalEmp && props.data.totalEmp) || 0}</Ptag>
                    </NumberDiv>
                </InnerDiv>
                </TotalEmployees>
                <TotalLives>
                <InnerDiv>
                    <img src={employee} width="50px" style={{ marginBottom: 35 }} />
                    <NumberDiv>
                    <Ptag fontSize="22px" fontWeight="600" color="#4A4A4A" lineHeight="30px" letterSpacing="0.61px" >Active Members</Ptag>
                    <Ptag fontSize="36px" fontWeight="600" color="#4A4A4A" lineHeight="49px" letterSpacing="1px" >{(props.data.totalLives && props.data.totalLives) || 0}</Ptag>
                    </NumberDiv>
                </InnerDiv>
                </TotalLives>
                </CareEmployeesBox> */}
        </>
      );
    }
  };

  renderSplitCards = (type, details, index) => {
    console.log({details})
    const splitDetails = [];
    if (details.number_of_employee >= 0)
      splitDetails.push({
        title:
          details.number_of_employee === 1 || details.number_of_employee === 0
            ? "EMPLOYEE"
            : "EMPLOYEES",
        number: details?.number_of_employee || 0,
      });
    if (details.no_of_lives >= 0)
      splitDetails.push({
        title:
          details.no_of_lives === 1 || details.no_of_lives === 0
            ? "LIFE"
            : "LIVES",
        number: details?.no_of_lives || 0
      });
    const topHeading =
      isFlexFlow() &&
      details.userplan_data &&
      (details.userplan_data.mandatory ? "Mandatory" : "Voluntary");
    let JSX = "";
    switch (type) {
      case "GMC":
        JSX = (
          <SplitDetailCard
            key={index}
            title="Group Mediclaim Cover"
            details={splitDetails}
            last_updated={details?.last_updated_at}
          />
        );
        break;
      case "GMC_M":
        JSX = (
          <SplitDetailCard
            key={index}
            title="Group Mediclaim Cover"
            details={splitDetails}
            last_updated={details?.last_updated_at}
          />
        );
        break;
      case "GPA":
        JSX = (
          <SplitDetailCard
            key={index}
            title="Group Personal Accident"
            details={splitDetails}
            last_updated={details?.last_updated_at}
          />
        );
        break;
      case "GTL":
        JSX = (
          <SplitDetailCard
            key={index}
            title="Group Term Life"
            details={splitDetails}
            last_updated={details?.last_updated_at}
          />
        );
        break;
      case "health_insurance":
        JSX = (
          <SplitDetailCard
            key={index}
            topHeading={topHeading === "Voluntary" && topHeading}
            title="Group Mediclaim Cover"
            details={splitDetails}
            last_updated={details?.last_updated_at}
          />
        );
        break;
      case "personal_accident":
        JSX = (
          <SplitDetailCard
            key={index}
            topHeading={topHeading === "Voluntary" && topHeading}
            title="Group Personal Accident"
            details={splitDetails}
            last_updated={details?.last_updated_at}
          />
        );
        break;
      case "term_life":
        JSX = (
          <SplitDetailCard
            key={index}
            topHeading={topHeading === "Voluntary" && topHeading}
            title="Group Term Life"
            details={splitDetails}
            last_updated={details?.last_updated_at}
          />
        );
        break;
      case "mandatory_top_up_health":
        JSX = (
          <SplitDetailCard
            topHeading={topHeading === "Voluntary" && topHeading}
            title="Mandatory Top Up Health"
            details={splitDetails}
            last_updated={details?.last_updated_at}
          />
        );
        break;
      case "top_up_health":
        JSX = (
          <SplitDetailCard
            topHeading={topHeading === "Voluntary" && topHeading}
            title="Group Top Up Health"
            details={splitDetails}
            last_updated={details?.last_updated_at}
          />
        );
        break;
      case "opd_cover":
        JSX = (
          <SplitDetailCard
            key={index}
            topHeading={topHeading === "Voluntary" && topHeading}
            title="OPD Cover"
            details={splitDetails}
            last_updated={details?.last_updated_at}
          />
        );
        break;
      case "critical_illness":
        JSX = (
          <SplitDetailCard
            key={index}
            topHeading={topHeading === "Voluntary" && topHeading}
            title="Critical Illness"
            details={splitDetails}
            last_updated={details?.last_updated_at}
          />
        );
        break;
      case "health_checkup":
        JSX = (
          <SplitDetailCard
            key={index}
            topHeading={topHeading === "Voluntary" && topHeading}
            title="Health Checkup"
            details={splitDetails}
            last_updated={details?.last_updated_at}
          />
        );
        break;
      case "parental_cover":
        JSX = (
          <SplitDetailCard
            key={index}
            topHeading={topHeading === "Voluntary" && topHeading}
            title="Group Parental Cover"
            details={splitDetails}
            last_updated={details?.last_updated_at}
          />
        );
        break;
      case "health_insurance_parents":
        JSX = (
          <SplitDetailCard
            key={index}
            topHeading={topHeading === "Voluntary" && topHeading}
            title="Group Mediclaim Cover (Parents)"
            details={splitDetails}
            last_updated={details?.last_updated_at}
          />
        );
        break;
      case "health_insurance_parents_in_laws":
        JSX = (
          <SplitDetailCard
            key={index}
            topHeading={topHeading === "Voluntary" && topHeading}
            title="Group Mediclaim Cover (Parents-In-Laws)"
            details={splitDetails}
            last_updated={details?.last_updated_at}
          />
        );
        break;
    }
    return JSX;
  };

  renderCareBox = () => {
    // const products = Object.keys(this.state.gmcMisData).sort((a, b) => {
    //     if (a.slice(0, 3) < b.slice(0, 3)) {
    //       return -1;
    //     } else if (a.slice(0, 3) > b.slice(0, 3)) {
    //       return 1;
    //     } else {
    //       return a.length < b.length ? -1 : 1;
    //     }
    // });
    const products = Object.keys(this.state.gmcMisData);
    if (isGmcFlow()) {
      return (
        <SplitWrapper>
          {products.map((prod, index) => {
            return this.renderSplitCards(
              prod,
              this.state.employeeData[prod]?.overallsummary,
              index
            );
          })}
        </SplitWrapper>
      );
    } else if (isFlexFlow()) {
      return (
        <SplitWrapper>
          {products.map((prod, index) => {
            return this.renderSplitCards(
              prod,
              this.state.gmcMisData[prod],
              index
            );
          })}
        </SplitWrapper>
      );
    } else {
      return (
        <CareEmployeesBox>
          <TotalEmployees>
            <InnerDiv>
              <img src={EmployeeIcon} width="50px" height="50px" />
              <NumberDiv>
                <Ptag fontSize="20px" fontWeight="600" letterSpacing="0.6px">
                  Active Employees
                </Ptag>
                <Ptag fontSize="36px" fontWeight="600" letterSpacing="1">
                  {this.state.overallsummary.number_of_employee || 0}
                </Ptag>
              </NumberDiv>
            </InnerDiv>
          </TotalEmployees>
          <TotalLives>
            <InnerDiv>
              <img src={MembersIcon} width="50px" height="50px" />
              <NumberDiv>
                <Ptag fontSize="20px" fontWeight="600" letterSpacing="0.6px">
                  Active Members
                </Ptag>
                <Ptag fontSize="36px" fontWeight="600" letterSpacing="1">
                  {this.state.overallsummary.no_of_lives || 0}
                </Ptag>
              </NumberDiv>
            </InnerDiv>
          </TotalLives>
          {this.state.showAnnualGmcFields && (
            <TotalLives>
              <InnerDiv>
                <img src={MembersIcon} width="50px" height="50px" />
                <NumberDiv>
                  <Ptag fontSize="20px" fontWeight="600" letterSpacing="0.6px">
                    Valid Till
                  </Ptag>
                  <Ptag fontSize="28px" fontWeight="600" letterSpacing="1">
                    {formatDateYYYY(this.state.next_billing_date) || "-"}
                  </Ptag>
                </NumberDiv>
              </InnerDiv>
            </TotalLives>
          )}
        </CareEmployeesBox>
      );
    }
  };

  renderPayDiv = () => {
    // const policy = this.state.employeeData["GMC"];

    return (
      <PayDiv>
        <Subscription>
          <Ptag
            fontSize="14px"
            textTransform="uppercase"
            letterSpacing="1px"
            lineHeight="14px"
          >
            SUBSCRIPTION
          </Ptag>
          <PricePart>
            {!!this.state.overallsummary["discount code"] && (
              <Ptag
                color="#7f7c7c"
                fontSize="18px"
                textDecoration="line-through"
              >
                {`₹${formatAmount(
                  Number(this.state.overallsummary["premium"] || 0) +
                    Number(this.state.overallsummary["platform_fee"] || 0) +
                    Number(this.state.overallsummary["tax"] || 0) +
                    Number(this.state.overallsummary["gpa_cost"] || 0)
                )}`}
              </Ptag>
            )}
            <Ptag
              fontSize="18px"
              letterSpacing="3px"
              lineHeight="33px"
              fontWeight="600"
            >
              {this.renderAmount()}
            </Ptag>
            <img
              src={eye}
              onClick={() => this.openPaymentPopup()}
              style={{ cursor: "pointer" }}
              height="24px"
              width="24px"
            ></img>
          </PricePart>
          {/* {
                        !!this.state.overallsummary['discount code'] &&
                        <DiscountDiv>
                            <Ptag color='#7f7c7c' fontSize='18px' textDecoration='line-through' >
                                {`₹${formatAmount((Number(this.state.overallsummary['premium'] || 0) + Number(this.state.overallsummary['platform_fee'] || 0) + this.state.overallsummary['tax']))}`}
                            </Ptag>
                            <Ptag fontSize='18px' color='#ff0000ba' fontWeight='600'  >
                                {`${this.state.overallsummary['discount code']}% Off`}
                            </Ptag>
                        </DiscountDiv>
                    } */}
        </Subscription>
        <Duedate>
          <Ptag
            fontSize="14px"
            textTransform="uppercase"
            letterSpacing="1px"
            lineHeight="14px"
          >
            DUE DATE
          </Ptag>
          <Ptag
            fontSize="18px"
            textAlign="center"
            letterSpacing="3px"
            marginTop="3px"
            lineHeight="33px"
            fontWeight="600"
          >
            {this.state.due_date || "-"}
          </Ptag>
        </Duedate>
      </PayDiv>
    );
  };

  generateTableData = (data) => {
    const reducer = (acc, value, index) => {
      const empData = data[value].employees_data;
      const newTableData = acc;
      empData.forEach((employee) => {
        const empIdx = acc.findIndex(
          (prevEmp) => prevEmp.employee_id === employee.employee_id
        );
        if (empIdx > -1) {
          newTableData[empIdx][value] = {
            policy_number: employee.policy_number,
            policy_status: employee.policy_status,
            employee_uhid: employee.employee_uhid,
            end_date: employee.end_date,
            start_date: employee.start_date,
            sum_insured: employee.sum_insured,
            refund: employee.refund,
          };
        } else {
          const obj = {
            name: employee.name,
            gender: employee.gender,
            dependents: employee.dependents,
            dob: employee.dob,
            email: employee.email,
            employee_id: employee.employee_id,
            enrollment_id: employee.enrollment_id,
            phone: employee.phone,
            no_of_dependents: employee.no_of_dependents,
            date_of_addition: employee.date_of_addition,
            date_of_deletion: employee.date_of_deletion,
            [value]: {
              policy_number: employee.policy_number,
              policy_status: employee.policy_status,
              employee_uhid: employee.employee_uhid,
              end_date: employee.end_date,
              start_date: employee.start_date,
              sum_insured: employee.sum_insured,
              refund: employee.refund,
            },
          };
          newTableData.push(obj);
        }
      });
      return newTableData;
    };
    return Object.keys(data).reduce(reducer, []);
  };

  isActivatedPolicyPresent = (detail) => {
    if (
      this.state.products.includes("GMC") &&
      detail["GMC"] &&
      detail["GMC"].policy_status === "ACTIVATED"
    ) {
      return true;
    }
    if (
      this.state.products.includes("GMC_M") &&
      detail["GMC_M"] &&
      detail["GMC_M"].policy_status === "ACTIVATED"
    ) {
      return true;
    }
    if (
      this.state.products.includes("GPA") &&
      detail["GPA"] &&
      detail["GPA"].policy_status === "ACTIVATED"
    ) {
      return true;
    }
    if (
      this.state.products.includes("GTL") &&
      detail["GTL"] &&
      detail["GTL"].policy_status === "ACTIVATED"
    ) {
      return true;
    }
    return false;
  };
  isActivatedFlexEmployee = (detail) => {
    return detail.policy_status === "ACTIVATED";
  };

  navigateToECardPreview = (detail) => {
    this.setState({
      navigateToPreviewEmployeeId: detail.employee_id,
    });
  };

  renderDesireProductTable = (product, tableData) => {
    this.setState({
      flexCurrentProductName: product,
      flexCurrentProductTableData: tableData,
      arrForSearch: tableData,
      filterText: "",
    });
    this.updateFilters(tableData.employees_data, null, true);
  };
  checkForColor = (name, value) => {
    return name == this.state.flexCurrentProductName;
  };

  flexProductList = () => {
    const productList = Object.entries(this.state.flexMisData);
    return (
      <>
        <FlexProductList>
          <thead>
            <tr>
              {productList.map(([productName, productValue], index) => {
                return (
                  // <th>
                  <IndividualList
                    key={index}
                    bgColor={
                      this.checkForColor(productName, productValue)
                        ? theme.primaryColor
                        : "transparent"
                    }
                    onClick={() =>
                      this.renderDesireProductTable(productName, productValue)
                    }
                  >
                    <Ptag
                      fontSize="14px"
                      textAlign="center"
                      lineHeight={1.3}
                      color={
                        this.checkForColor(productName, productValue)
                          ? "white"
                          : theme.primaryColor
                      }
                      fontWeight="600 !important"
                    >
                      {FLEX_PRODUCTS[productName]}
                    </Ptag>
                  </IndividualList>
                  // </th>
                );
              })}
            </tr>
          </thead>
        </FlexProductList>
      </>
    );
  };

  renderMis = () => {
    //source : https://codepen.io/gc-nomade/pen/vaNoEQ?editors=1100
    const getBgColorRed = (individualPolicy) => {
      if (
        individualPolicy.policy_status === "DELETION INITIATED" ||
        individualPolicy.policy_status === "STOPPED"
      ) {
        return true;
      }
      if (
        individualPolicy["GMC"] &&
        ["DELETION INITIATED", "STOPPED"].includes(
          individualPolicy["GMC"].policy_status
        )
      ) {
        return true;
      }
      if (
        individualPolicy["GMC_M"] &&
        ["DELETION INITIATED", "STOPPED"].includes(
          individualPolicy["GMC_M"].policy_status
        )
      ) {
        return true;
      }
      if (
        individualPolicy["GPA"] &&
        ["DELETION INITIATED", "STOPPED"].includes(
          individualPolicy["GPA"].policy_status
        )
      ) {
        return true;
      }
      if (
        individualPolicy["GTL"] &&
        ["DELETION INITIATED", "STOPPED"].includes(
          individualPolicy["GTL"].policy_status
        )
      ) {
        return true;
      }
      return false;
    };

    const tableStyle = (individualPolicy, index) => {
      const isAnnualGmcFieldsShown = this.state.showAnnualGmcFields;
      const isBgColorRed = getBgColorRed(individualPolicy);
      const isIndexEven = index % 2 === 0;
      const isRenewal =
        individualPolicy.updated_amount && getRenewal(individualPolicy);

      const style = {
        background: isBgColorRed
          ? "rgba(242,158,158)"
          : isIndexEven
          ? "#ffffff"
          : "#D0D9E9",
        height: 48,
      };

      if (isAnnualGmcFieldsShown) {
        return style;
      } else if (isBgColorRed) {
        return { background: "rgba(242,158,158)" };
      } else {
        if (isRenewal) {
          style.borderColor = "#436AB2";
          style.borderStyle = "solid";
          style.borderWidth = "2px";
        }
        return style;
      }
    };

    const getWidth = (individualPolicy) => {
      return individualPolicy.updated_amount != individualPolicy.total_amount &&
        individualPolicy.updated_amount != 0
        ? "600"
        : "500";
    };

    const getRenewal = (individualPolicy) => {
      return individualPolicy.updated_amount != individualPolicy.total_amount &&
        individualPolicy.updated_amount != 0
        ? true
        : false;
    };
    const renderTableHeaders = (text, sticky, subtitle) => {
      let JSX = (
        <th>
          <TopHeader>
            <Ptag
              fontSize="14px"
              textAlign="center"
              lineHeight={1.3}
              color={theme.primaryColor}
              fontWeight="600 !important"
            >
              {text}
            </Ptag>
            {subtitle && <Ptag marginLeft="27px">{subtitle}</Ptag>}
          </TopHeader>
        </th>
      );
      if (sticky) {
        JSX = (
          <StickyCell>
            <TopHeader>
              <Ptag
                fontSize="14px"
                textAlign="center"
                lineHeight={1.3}
                color={theme.primaryColor}
                fontWeight="600 !important"
              >
                {text}
              </Ptag>
              {subtitle && <Ptag marginLeft="27px">{subtitle}</Ptag>}
            </TopHeader>
          </StickyCell>
        );
      }
      return JSX;
    };
    const renderTableCell = (individualPolicy, text) => {
      return (
        <td>
          <TopHeader>
            <Ptag
              textAlign="center"
              fontSize="14px"
              lineHeight={1.3}
              fontWeight={
                individualPolicy.updated_amount && getWidth(individualPolicy)
              }
            >
              {text}
            </Ptag>
          </TopHeader>
        </td>
      );
    };

    const getProductStatusChip = (productName, productStatus) => {
      switch (productStatus) {
        case "ACTIVATION PENDING":
          return <Chip background="#F7CB59" text={`${productName} Pending`} />;
        case "ACTIVATED":
          return (
            <Chip background="#81C14B" text={`${productName} Activated`} />
          );
        case "DELETION INITIATED":
          return (
            <Chip
              background="#FF9446"
              text={`${productName} Deletion Initiated`}
            />
          );
        case "STOPPED":
          return <Chip background="#F27576" text={`${productName} Stopped`} />;
        default:
          return null;
      }
    };
    const getFlexProductStatus = (detail) => {
      const productStatus = detail.policy_status;
      switch (productStatus) {
        case "ACTIVATION PENDING":
          return <Chip background="#F7CB59" text={` Pending`} />;
        case "ACTIVATED":
          return <Chip background="#81C14B" text={`Activated`} />;
        case "DELETION INITIATED":
          return <Chip background="#FF9446" text={`Deletion Initiated`} />;
        case "STOPPED":
          return <Chip background="#F27576" text={`Stopped`} />;
        default:
          return null;
      }
    };

    const renderStatusChips = (individualPolicy) => {
      let JSX = [];
      const gmcExist = individualPolicy["GMC"];
      const gmcMaternityExist = individualPolicy["GMC_M"];
      const gpaExist = individualPolicy["GPA"];
      const gtlExist = individualPolicy["GTL"];

      const gmcStatus = gmcExist && individualPolicy["GMC"].policy_status;
      const gmcMaternityStatus =
        gmcMaternityExist && individualPolicy["GMC_M"].policy_status;
      const gpaStatus = gpaExist && individualPolicy["GPA"].policy_status;
      const gtlStatus = gtlExist && individualPolicy["GTL"].policy_status;

      if (this.state.products.includes("GMC")) {
        JSX.push(getProductStatusChip("GHI", gmcStatus));
      }
      if (this.state.products.includes("GMC_M")) {
        JSX.push(getProductStatusChip("GHI", gmcMaternityStatus));
      }

      if (this.state.products.includes("GPA")) {
        JSX.push(getProductStatusChip("GPA", gpaStatus));
      }

      if (this.state.products.includes("GTL")) {
        JSX.push(getProductStatusChip("GTL", gtlStatus));
      }
      return (
        <section style={{ gap: "0.6rem", display: "flex" }}>
          {JSX.map((el) => el)}
        </section>
      );
    };

    const renderAttributeValues = (row) => {
      const attrIds =
        this.state.flexCurrentProductTableData.overallsummary.userplan_data.attributes_data
          .filter((attribute) => attribute.employee_visibility)
          .map((attr) => attr.attribute_id);

      return attrIds.map((attrId) => {
        const attr = row.attributes_data.find(
          (attr) => attr.attribute === attrId
        );
        return (
          <td>
            <TopHeader>
              <Ptag textAlign="center" fontSize="14px" lineHeight={1.3}>
                {attr.selected_value || attr.default_value || "-"}
              </Ptag>
            </TopHeader>
          </td>
        );
      });
    };

    if (isGmcFlow() && this.state.tableData.length) {
      const showGmcColumn =
        this.state.products.includes("GMC") ||
        this.state.products.includes("GMC_M");
      const showGpaColumn = this.state.products.includes("GPA");
      const showGtlColumn = this.state.products.includes("GTL");

      const stoppedOptions = ["STOPPED", "DELETION INITIATED"];

      const stoppedProds = this.state.tableData.filter((pol) => {
        if (stoppedOptions.includes(pol?.GMC?.policy_status)) return true;
        if (stoppedOptions.includes(pol?.GMC_M?.policy_status)) return true;
        if (stoppedOptions.includes(pol?.GPA?.policy_status)) return true;
        if (stoppedOptions.includes(pol?.GTL?.policy_status)) return true;
      });
      const stoppedEmployeeIds = stoppedProds.map((pol) => pol.employee_id);
      const remainingProds = this.state.tableData.filter(
        (pol) => !stoppedEmployeeIds.includes(pol.employee_id)
      );
      const sortedTableData = [...remainingProds, ...stoppedProds];

      return (
        <TableWrapper>
          <Table id="table-to-xls" width="100%" cellSpacing="0" cellPadding="6">
            <thead>
              <tr>
                {renderTableHeaders("Employee ID", true)}
                {renderTableHeaders("Name")}
                {renderTableHeaders("Gender")}
                {renderTableHeaders("Date of Birth")}
                {renderTableHeaders("Email")}
                {renderTableHeaders("Mobile")}
                {renderTableHeaders("Dependents")}
                {showGmcColumn && <>{renderTableHeaders("GHI Cover")}</>}
                {showGpaColumn && <>{renderTableHeaders("GPA Cover")}</>}
                {showGtlColumn && <>{renderTableHeaders("GTL Cover")}</>}
                {renderTableHeaders("E-Card")}
                <th>
                  <TopHeader>
                    <Ptag
                      fontSize="14px"
                      textAlign="left"
                      lineHeight={1.3}
                      color={theme.primaryColor}
                      fontWeight="600 !important"
                    >
                      Status
                    </Ptag>
                  </TopHeader>
                </th>
              </tr>
            </thead>
            <tbody>
              {sortedTableData.map((individualPolicy, index) => (
                <tr key={index} style={{ background: "#fff" }}>
                  <StickyCell bgColor="#fff">
                    <TopHeader>
                      <Ptag
                        textAlign="center"
                        fontSize="14px"
                        lineHeight={1.3}
                        fontWeight={
                          individualPolicy.updated_amount &&
                          getWidth(individualPolicy)
                        }
                      >
                        {individualPolicy.enrollment_id || "-"}
                      </Ptag>
                    </TopHeader>
                  </StickyCell>
                  {/* <AnnualRow > */}
                  {renderTableCell(individualPolicy, individualPolicy.name)}
                  {renderTableCell(
                    individualPolicy,
                    toTitleCase(individualPolicy.gender)
                  )}
                  {renderTableCell(
                    individualPolicy,
                    individualPolicy.dob || "-"
                  )}
                  {renderTableCell(
                    individualPolicy,
                    individualPolicy.email || "-"
                  )}
                  {renderTableCell(
                    individualPolicy,
                    individualPolicy.phone || "-"
                  )}
                  {renderTableCell(
                    individualPolicy,
                    individualPolicy.no_of_dependents
                  )}
                  {showGmcColumn && (
                    <>
                      {individualPolicy["GMC"]
                        ? renderTableCell(
                            individualPolicy,
                            individualPolicy["GMC"]?.sum_insured
                              ? `₹${formatAmount(
                                  individualPolicy["GMC"]?.sum_insured
                                )}`
                              : "-"
                          )
                        : renderTableCell(
                            individualPolicy,
                            individualPolicy["GMC_M"]?.sum_insured
                              ? `₹${formatAmount(
                                  individualPolicy["GMC_M"]?.sum_insured
                                )}`
                              : "-"
                          )}
                    </>
                  )}
                  {showGpaColumn && (
                    <>
                      {renderTableCell(
                        individualPolicy,
                        individualPolicy["GPA"]?.sum_insured
                          ? `₹${formatAmount(
                              individualPolicy["GPA"]?.sum_insured
                            )}`
                          : "-"
                      )}
                    </>
                  )}
                  {showGtlColumn && (
                    <>
                      {renderTableCell(
                        individualPolicy,
                        individualPolicy["GTL"]?.sum_insured
                          ? `₹${formatAmount(
                              individualPolicy["GTL"]?.sum_insured
                            )}`
                          : "-"
                      )}
                    </>
                  )}
                  <TopHeader>
                    <td>
                      {this.isActivatedPolicyPresent(individualPolicy) ? (
                        <DownloadLink
                          onClick={() =>
                            this.navigateToECardPreview(individualPolicy)
                          }
                        >
                          View
                        </DownloadLink>
                      ) : (
                        <Ptag
                          textAlign="center"
                          fontSize="14px"
                          lineHeight={1.3}
                          fontWeight="500"
                        >
                          -
                        </Ptag>
                      )}
                    </td>
                  </TopHeader>
                  <td>
                    <TopHeader style={{ display: "flex" }}>
                      {renderStatusChips(individualPolicy)}
                    </TopHeader>
                  </td>
                  {/* </Ptag> */}
                </tr>
              ))}
            </tbody>
          </Table>
        </TableWrapper>
      );
    } else if (isFlexFlow()) {
      const currentTable = this.state.flexCurrentProductTableData;

      const stoppedOptions = ["STOPPED", "DELETION INITIATED"];

      const stoppedProds = this.state.tableData.filter((pol) => {
        if (stoppedOptions.includes(pol?.GMC?.policy_status)) return true;
        if (stoppedOptions.includes(pol?.GMC_M?.policy_status)) return true;
        if (stoppedOptions.includes(pol?.GPA?.policy_status)) return true;
        if (stoppedOptions.includes(pol?.GTL?.policy_status)) return true;
      });
      const stoppedEmployeeIds = stoppedProds.map((pol) => pol.employee_id);
      const remainingProds = this.state.tableData.filter(
        (pol) => !stoppedEmployeeIds.includes(pol.employee_id)
      );
      const sortedTableData = [...remainingProds, ...stoppedProds];

      const renderAttributeHeaders = () => {
        const attributesData =
          this.state.flexCurrentProductTableData.overallsummary.userplan_data
            .attributes_data;
        return attributesData
          .filter((attribute) => attribute.employee_visibility)
          .map(({ attribute_name }, index) => {
            return (
              <th>
                <TopHeader>
                  <Ptag
                    fontSize="14px"
                    textAlign="center"
                    lineHeight={1.3}
                    color={theme.primaryColor}
                    fontWeight="600 !important"
                  >
                    {attribute_name}
                  </Ptag>
                </TopHeader>
              </th>
            );
          });
      };

      return (
        <TableWrapper>
          <Table id="table-to-xls" width="100%" cellSpacing="0" cellPadding="6">
            <thead>
              <tr>
                {renderTableHeaders("Employee ID", true)}
                {renderTableHeaders("Name")}
                {renderTableHeaders("Gender")}
                {renderTableHeaders("Date of Birth")}
                {renderTableHeaders("Email")}
                {renderTableHeaders("Mobile")}
                {renderTableHeaders("Dependents")}
                {renderTableHeaders("Cover Start Date")}
                {renderAttributeHeaders()}
                {renderTableHeaders("E-Card")}
                <th>
                  <TopHeader>
                    <Ptag
                      fontSize="14px"
                      textAlign="left"
                      lineHeight={1.3}
                      color={theme.primaryColor}
                      fontWeight="600 !important"
                    >
                      Status
                    </Ptag>
                  </TopHeader>
                </th>
              </tr>
            </thead>
            <tbody>
              {currentTable.employees_data.map((individualPolicy, index) => (
                <tr key={index} style={{ background: "#fff" }}>
                  <StickyCell bgColor="#fff">
                    <TopHeader>
                      <Ptag
                        textAlign="center"
                        fontSize="14px"
                        lineHeight={1.3}
                        fontWeight={
                          individualPolicy.updated_amount &&
                          getWidth(individualPolicy)
                        }
                      >
                        {individualPolicy.enrollment_id || "-"}
                      </Ptag>
                    </TopHeader>
                  </StickyCell>
                  {renderTableCell(individualPolicy, individualPolicy.name)}
                  {renderTableCell(
                    individualPolicy,
                    toTitleCase(individualPolicy.gender)
                  )}
                  {renderTableCell(
                    individualPolicy,
                    individualPolicy.dob || "-"
                  )}
                  {renderTableCell(
                    individualPolicy,
                    individualPolicy.email || "-"
                  )}
                  {renderTableCell(
                    individualPolicy,
                    individualPolicy.phone || "-"
                  )}
                  {renderTableCell(
                    individualPolicy,
                    individualPolicy.no_of_dependents
                  )}
                  {renderTableCell(
                    individualPolicy,
                    individualPolicy.start_date || "-"
                  )}
                  {renderAttributeValues(individualPolicy)}
                  <TopHeader>
                    <td>
                      {this.isActivatedFlexEmployee(individualPolicy) ? (
                        <DownloadLink
                          onClick={() =>
                            this.navigateToECardPreview(individualPolicy)
                          }
                        >
                          View
                        </DownloadLink>
                      ) : (
                        <Ptag
                          textAlign="center"
                          fontSize="14px"
                          lineHeight={1.3}
                          fontWeight="500"
                        >
                          -
                        </Ptag>
                      )}
                    </td>
                  </TopHeader>
                  <td>
                    <TopHeader style={{ display: "flex" }}>
                      {getFlexProductStatus(individualPolicy)}
                    </TopHeader>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </TableWrapper>
      );
    } else {
      return (
        <TableWrapper>
          <Table id="table-to-xls" width="100%" cellSpacing="0" cellPadding="6">
            <thead>
              <tr>
                {!this.state.showAnnualGmcFields && (
                  <StickyCell style={{ padding: "10px" }}>
                    <input
                      onChange={() => this.selectAllPolicies()}
                      checked={this.areAllPoliciesSelected()}
                      type="checkbox"
                    />
                  </StickyCell>
                )}
                {this.state.showAnnualGmcFields &&
                  renderTableHeaders("Employee UHID")}
                {renderTableHeaders("Name", true)}
                {renderTableHeaders("Gender")}
                {renderTableHeaders("Date of Birth")}
                {renderTableHeaders("Email")}
                {renderTableHeaders("Mobile")}
                {renderTableHeaders("No of Dependents")}
                {this.state.showAnnualGmcFields &&
                  renderTableHeaders("Start Date")}
                {renderTableHeaders("Sum Insured")}
                {!this.state.showAnnualGmcFields &&
                  renderTableHeaders("Subscription Amount")}
                {!this.state.showAnnualGmcFields &&
                  renderTableHeaders("Date of Addition")}
                {!this.state.showAnnualGmcFields &&
                  renderTableHeaders("Policy No.")}
                {!this.state.showAnnualGmcFields &&
                  renderTableHeaders("Date of Deletion")}
                {this.state.showAnnualGmcFields &&
                  renderTableHeaders("Premium", false, "(Inclusive Tax)")}
                {this.state.showAnnualGmcFields &&
                  renderTableHeaders("End Date")}
                {this.state.showAnnualGmcFields && renderTableHeaders("Refund")}
                {renderTableHeaders("Status")}
              </tr>
            </thead>

            <tbody>
              {this.state.policies &&
                this.state.policies.map((individualPolicy, index) => (
                  // <tr key={index} style={individualPolicy.policy_status === 'STOPPED' ? { background: 'rgba(242,158,158)' } : !(index % 2) ? { background: "#fff", height: 48} : { background: "rgb(208, 217, 233)", height: 48}}>
                  <tr key={index} style={tableStyle(individualPolicy, index)}>
                    {/* <Ptag style={individualPolicy.updated_amount > 0 ? {borderStyle:'solid', borderColour: 'red'} : {borderStyle: 'white'}}> */}

                    {/* <ListRow values={individualPolicy.policy_status} key={index}>  */}
                    {/* <tr style={index % 2 ? { background: "#e4edff", height: 48 } : { background: "#ffffff", height: 48 }}> */}
                    {!this.state.showAnnualGmcFields &&
                      (individualPolicy.policy_status !== "STOPPED" ? (
                        <StickyCell
                          bgColor={
                            individualPolicy.policy_status === "STOPPED"
                              ? "rgba(242,158,158)"
                              : !(index % 2)
                              ? "#fff"
                              : "#D0D9E9"
                          }
                          style={{ padding: "10px", textAlign: "center" }}
                        >
                          <input
                            disabled={
                              individualPolicy.policy_status === "STOPPED"
                            }
                            onChange={() => this.onSelectPolicyItem(index)}
                            checked={individualPolicy["isChecked"]}
                            type="checkbox"
                          />
                        </StickyCell>
                      ) : (
                        <StickyCell></StickyCell>
                      ))}

                    {this.state.showAnnualGmcFields && (
                      <StickyCell
                        bgColor={
                          getBgColorRed(individualPolicy)
                            ? "rgba(242,158,158)"
                            : index % 2 === 0
                            ? "#ffffff"
                            : "#D0D9E9"
                        }
                      >
                        <TopHeader>
                          <Ptag
                            textAlign="center"
                            fontSize="14px"
                            lineHeight={1.3}
                            fontWeight={
                              individualPolicy.updated_amount &&
                              getWidth(individualPolicy)
                            }
                          >
                            {individualPolicy.employee_uhid || "-"}
                          </Ptag>
                        </TopHeader>
                      </StickyCell>
                    )}

                    <StickyCell
                      bgColor={
                        getBgColorRed(individualPolicy)
                          ? "rgba(242,158,158)"
                          : index % 2 === 0
                          ? "#ffffff"
                          : "#D0D9E9"
                      }
                    >
                      <TopHeader>
                        <Ptag
                          textAlign="center"
                          fontSize="14px"
                          lineHeight={1.3}
                          fontWeight={
                            individualPolicy.updated_amount &&
                            getWidth(individualPolicy)
                          }
                        >
                          {individualPolicy.name}
                        </Ptag>
                      </TopHeader>
                    </StickyCell>
                    {/* <AnnualRow > */}
                    {renderTableCell(
                      individualPolicy,
                      toTitleCase(individualPolicy.gender)
                    )}
                    {renderTableCell(
                      individualPolicy,
                      individualPolicy.dob || "-"
                    )}
                    {renderTableCell(individualPolicy, individualPolicy.email)}
                    {renderTableCell(individualPolicy, individualPolicy.phone)}
                    {renderTableCell(
                      individualPolicy,
                      individualPolicy.no_of_dependents
                    )}
                    {this.state.showAnnualGmcFields &&
                      renderTableCell(
                        individualPolicy,
                        individualPolicy.start_date || "-"
                      )}
                    {renderTableCell(
                      individualPolicy,
                      `₹${formatAmount(individualPolicy.sum_insured) || 0}`
                    )}
                    {!this.state.showAnnualGmcFields &&
                      (individualPolicy.updated_amount &&
                      getRenewal(individualPolicy) ? (
                        <td>
                          <TopHeader>
                            <Ptag
                              textAlign="center"
                              fontSize="14px"
                              lineHeight={1.3}
                            >
                              <AmountTag
                                style={{
                                  fontWeight: "600",
                                  fontSize: "18px",
                                  lineHeight: "27.24px",
                                  letterSpacing: "0.56px",
                                }}
                              >
                                ₹{formatAmount(individualPolicy.updated_amount)}
                                <RenewTag
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: "400",
                                    padding: "3px 0px 0px 4px",
                                    color: "#4a4a4a",
                                    letterSpacing: "0.88px",
                                    fontStretch: "normal",
                                    fontStyle: "normal",
                                  }}
                                >
                                  ₹{individualPolicy.total_amount}
                                </RenewTag>
                              </AmountTag>
                              <TextTag
                                style={{
                                  fontWeight: "400",
                                  lineHeight: "12px",
                                  fontSize: "12px",
                                  minWidth: "180px",
                                }}
                              >
                                <Ptag>
                                  <img
                                    src={renewalprice}
                                    width="18px"
                                    height="18px"
                                    style={{ marginRight: 10 }}
                                  />
                                </Ptag>
                                Increased due to change in age band
                              </TextTag>
                            </Ptag>
                          </TopHeader>
                        </td>
                      ) : (
                        <td>
                          <TopHeader>
                            <Ptag
                              textAlign="center"
                              fontSize="14px"
                              lineHeight={1.3}
                              fontWeight={
                                individualPolicy.updated_amount &&
                                getWidth(individualPolicy)
                              }
                            >
                              ₹
                              {formatAmount(individualPolicy.total_amount) || 0}
                            </Ptag>
                          </TopHeader>
                        </td>
                      ))}
                    {!this.state.showAnnualGmcFields &&
                      renderTableCell(
                        individualPolicy,
                        individualPolicy.date_of_addition || "-"
                      )}
                    {!this.state.showAnnualGmcFields &&
                      renderTableCell(
                        individualPolicy,
                        individualPolicy.policy_number || "-"
                      )}
                    {!this.state.showAnnualGmcFields &&
                      renderTableCell(
                        individualPolicy,
                        individualPolicy.date_of_deletion || "-"
                      )}
                    {this.state.showAnnualGmcFields &&
                      renderTableCell(
                        individualPolicy,
                        `₹${formatAmount(individualPolicy.premium) || 0}`
                      )}
                    {/* {
                                                this.state.showAnnualGmcFields && 
                                                <td ><TopHeader><Ptag textAlign='center' fontSize="16px" lineHeight={1.3} fontWeight={individualPolicy.updated_amount && getWidth(individualPolicy)}>₹{formatAmount(individualPolicy.wellness_fee) || 0}</Ptag></TopHeader></td>
                                            } */}
                    {this.state.showAnnualGmcFields &&
                      renderTableCell(
                        individualPolicy,
                        individualPolicy.policy_status == "STOPPED"
                          ? individualPolicy.date_of_deletion
                          : individualPolicy.end_date || "-"
                      )}
                    {this.state.showAnnualGmcFields &&
                      renderTableCell(
                        individualPolicy,
                        `₹${formatAmount(individualPolicy.refund) || 0}`
                      )}
                    {renderTableCell(
                      individualPolicy,
                      toTitleCase(individualPolicy.policy_status)
                    )}
                    {/* </Ptag> */}
                  </tr>
                ))}
            </tbody>
          </Table>
        </TableWrapper>
      );
    }
  };

  renderAmount = () => {
    return `₹${formatAmount(
      Number(this.state.overallsummary["premium"] || 0) +
        Number(this.state.overallsummary["gpa_cost"] || 0) +
        Number(this.state.overallsummary["platform_fee"] || 0) -
        Number(this.state.overallsummary["discount"] || 0) +
        Number(
          this.state.overallsummary["discounted_tax"]
            ? this.state.overallsummary["discounted_tax"]
            : this.state.overallsummary["tax"]
        )
    )} `;
  };

  search = debounce((e) => {
    var searchText = trim(e.target.value);
    if (searchText.length > 0) {
      var newArr = findInValues(this.state.policies, searchText);
      this.setState({ policies: newArr });
    } else {
      this.setState({
        policies: this.state.arrForSearch,
        filterText: "Filter",
      });
    }
  }, 100);

  searchMisTable = debounce((e) => {
    var searchText = trim(e.target.value);
    if (isGmcFlow()) {
      if (searchText.length > 0) {
        var newArr = findInValues(this.state.arrForSearch, searchText);
        this.setState({ tableData: newArr, filterText: "Filter" });
      } else {
        this.setState({
          tableData: this.state.arrForSearch,
          filterText: "Filter",
        });
      }
    } else if (isFlexFlow()) {
      if (searchText.length > 0) {
        var newArr = findInValues(
          this.state.flexCurrentProductTableData.employees_data,
          searchText
        );
        const tableData = Object.entries(this.state.flexMisData).reduce(
          (obj, [productName, productValue]) => {
            obj[productName] = findInValues(
              productValue.employees_data,
              searchText
            );
            return obj;
          },
          {}
        );
        Object.entries(tableData).forEach(([key, value]) => {
          this.setState((prevState) => ({
            flexMisData: {
              ...prevState.flexMisData,
              [key]: { ...prevState.flexMisData[key], employees_data: value },
            },
          }));
        });

        this.setState({
          flexCurrentProductTableData: {
            ...this.state.flexCurrentProductTableData,
            employees_data: newArr,
          },
          filterText: "Filter",
        });
      } else {
        this.setState({ flexMisData: this.state.gmcMisData });
        this.setState({
          flexCurrentProductTableData: this.state.arrForSearch,
          filterText: "Filter",
        });
      }
    } else {
      if (searchText.length > 0) {
        var newArr = findInValues(this.state.policies, searchText);
        this.setState({ policies: newArr });
      } else {
        this.setState({
          policies: this.state.arrForSearch,
          filterText: "Filter",
        });
      }
    }
  }, 100);

  filter = (event) => {
    const val = event.target.value;
    if (val === "none") {
      if (isFlexFlow()) {
        this.setState({
          policies: this.state.arrForSearch.employees_data,
          filterText: val,
          tableData: this.state.arrForSearch.employees_data,
          flexCurrentProductTableData: {
            ...this.state.flexCurrentProductTableData,
            employees_data: this.state.arrForSearch.employees_data,
          },
        });
      } else {
        this.setState({
          policies: this.state.arrForSearch,
          filterText: val,
          tableData: this.state.arrForSearch,
        });
      }
    } else if (!isGmcFlow() && !isFlexFlow()) {
      const filteredArray = this.state.arrForSearch.filter(
        (member) => member.policy_status === upperCase(val)
      );
      this.setState({ policies: filteredArray, filterText: toTitleCase(val) });
    } else if (isFlexFlow()) {
      let text;
      switch (val.toLowerCase()) {
        case "pending":
          text = "ACTIVATION PENDING";
          break;
        case "activated":
          text = "ACTIVATED";
          break;
        case "deletion initiated":
          text = "DELETION INITIATED";
          break;
        case "stopped":
          text = "STOPPED";
          break;
      }
      const filteredArray = this.state.arrForSearch.employees_data.filter(
        (member) => member.policy_status === text
      );
      this.setState({
        policies: filteredArray,
        filterText: toTitleCase(val),
        tableData: filteredArray,
        flexCurrentProductTableData: {
          ...this.state.flexCurrentProductTableData,
          employees_data: filteredArray,
        },
      });
    } else {
      const filteredArray = this.state.arrForSearch.filter((member) => {
        const gmcForUserExist = member["GMC"];
        const gmcMaternityForUserExist = member["GMC_M"];
        const gpaForUserExist = member["GPA"];
        const gtlForUserExist = member["GTL"];
        switch (val) {
          case "ghi activated":
            if (
              gmcForUserExist &&
              gmcForUserExist.policy_status === "ACTIVATED"
            )
              return true;
            if (
              gmcMaternityForUserExist &&
              gmcMaternityForUserExist.policy_status === "ACTIVATED"
            )
              return true;
            break;
          case "gpa activated":
            if (
              gpaForUserExist &&
              gpaForUserExist.policy_status === "ACTIVATED"
            )
              return true;
            break;
          case "gtl activated":
            if (
              gtlForUserExist &&
              gtlForUserExist.policy_status === "ACTIVATED"
            )
              return true;
            break;
          case "ghi pending":
            if (member["GMC"]?.policy_status === "ACTIVATION PENDING")
              return true;
            if (member["GMC_M"]?.policy_status === "ACTIVATION PENDING")
              return true;
            break;
          case "gpa pending":
            if (member["GPA"]?.policy_status === "ACTIVATION PENDING")
              return true;
            break;
          case "gtl pending":
            if (member["GTL"]?.policy_status === "ACTIVATION PENDING")
              return true;
            break;
          case "ghi deletion initiated":
            if (
              this.state.products.includes("GMC") &&
              gmcForUserExist &&
              member["GMC"]?.policy_status === "DELETION INITIATED"
            )
              return true;
            if (
              this.state.products.includes("GMC_M") &&
              gmcMaternityForUserExist &&
              member["GMC_M"]?.policy_status === "DELETION INITIATED"
            )
              return true;
            break;
          case "gpa deletion initiated":
            if (
              this.state.products.includes("GPA") &&
              gpaForUserExist &&
              member["GPA"]?.policy_status === "DELETION INITIATED"
            )
              return true;
            break;
          case "gtl deletion initiated":
            if (
              this.state.products.includes("GTL") &&
              gtlForUserExist &&
              member["GTL"]?.policy_status === "DELETION INITIATED"
            )
              return true;
            break;
          case "ghi stopped":
            if (
              this.state.products.includes("GMC") &&
              gmcForUserExist &&
              member["GMC"]?.policy_status === "STOPPED"
            )
              return true;
            if (
              this.state.products.includes("GMC_M") &&
              gmcMaternityForUserExist &&
              member["GMC_M"]?.policy_status === "STOPPED"
            )
              return true;
            break;
          case "gpa stopped":
            if (
              this.state.products.includes("GPA") &&
              gpaForUserExist &&
              member["GPA"]?.policy_status === "STOPPED"
            )
              return true;
            break;
          case "gtl stopped":
            if (
              this.state.products.includes("GTL") &&
              gtlForUserExist &&
              member["GTL"]?.policy_status === "STOPPED"
            )
              return true;
            break;
        }

        return false;
      });

      this.setState({
        policies: filteredArray,
        filterText: toTitleCase(val),
        tableData: filteredArray,
      });
    }
  };
  navigeteToAddDeletPage = () => {
    if (isGmcFlow()) {
      this.props.navigate("/addDeleteEmoployee");
    } else {
      const flex_userplan_ids = Object.keys(this.state.flexMisData).reduce(
        (acc, key) => {
          acc[key] = this.state.flexMisData[key].overallsummary.userplan;
          return acc;
        },
        {}
      );
      localStorage.setItem(
        "flex_userplan_ids",
        JSON.stringify(flex_userplan_ids)
      );
      this.props.navigate("/flex/setup/master", {
        state: { flow: "add_delete" },
      });
    }
  };

  exportCsv = () => {
    var csvStr =
      '"Name","Gender","Date of Birth","Email","Mobile","Dependents","Sum Insured","Subscription Amount","Date of Addtion","Policy No.","Status","Date of Deletion","Dependent1",,,,"Dependent2",,,,"Dependent3",,,,"Dependent4",,,,"Dependent5",,,,"Dependent6",,,\n,,,,,,,,,,,,,"Dependent Type","First Name","Last Name","DOB","Dependent Type","First Name","Last Name","DOB","Dependent Type","First Name","Last Name","DOB","Dependent Type","First Name","Last Name","DOB","Dependent Type","First Name","Last Name","DOB","Dependent Type","First Name","Last Name","DOB"\n';
    this.state.policies.forEach((item) => {
      csvStr = csvStr + (item.name || "") + ",";
      csvStr = csvStr + (item.gender || "") + ",";
      csvStr = csvStr + (item.dob || "") + ",";
      csvStr = csvStr + (item.email || "") + ",";
      csvStr = csvStr + (item.phone || "") + ",";
      csvStr = csvStr + (item.no_of_dependents || "") + ",";
      csvStr = csvStr + (item.sum_insured || "") + ",";
      csvStr = csvStr + (item.total_amount || "") + ",";
      csvStr = csvStr + (item.date_of_addition || "") + ",";
      csvStr = csvStr + (item.policy_number || "") + ",";
      csvStr = csvStr + (item.policy_status || "") + ",";
      csvStr = csvStr + (item.date_of_deletion || "") + ",";
      for (let i = 0; i < item.dependents.length; i++) {
        const role = item.dependents[i];
        csvStr = csvStr + (role.relation || "") + ",";
        csvStr = csvStr + (role.first_name || "") + ",";
        csvStr = csvStr + (role.last_name || "") + ",";
        csvStr = csvStr + (role.dob || "") + ",";
      }
      csvStr = csvStr + "\n";
    });
    // this.setState({ csvArr: data }, () => { console.log(this.state.csvArr) })
    const element = document.createElement("a");
    const fileOutput = csvStr;
    const file = new Blob([fileOutput], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download =
      (this.state.company_name &&
        this.state.company_name.split(/[\s.]+/)[0] + "_employee.csv") ||
      "Employee_Details.csv";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
    element.parentNode.removeChild(element);
  };

  downloadExcel = async () => {
    if (!isGmcFlow() && !isFlexFlow()) {
      this.exportCsv();
      return;
    }
    let downloadApi = "",
      payload = {};
    if (isGmcFlow()) {
      downloadApi = "business/download_mis_data/";
      payload = this.state.employeeData;
    } else {
      downloadApi = "business/download_flex_mis_data/";
    }
    let { data } = await http.post(downloadApi, payload, {
      responseType: "blob",
    });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(new Blob([data]));
    link.download = "employee_data.xlsx";

    // Append link to the DOM and click it
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
    // const tableEl = document.getElementById("excel-to-be-downloaded");
    // const wb = XLSX.utils.table_to_book(tableEl);

    // /* Export to file (start a download) */
    // XLSX.writeFile(wb, "mis_table.xlsx");
  };

  downloadExcelTable = () => {
    const numbers = Array.from({ length: 5 }, (_, i) => i + 1);
    const generateDependentsHeaders = () => {
      return numbers.map((_) => (
        <>
          <th>Dependent Type</th>
          <th>First Name</th>
          <th>Last Name</th>
          <th>DOB</th>
        </>
      ));
    };
    const generateProductsHeaders = () => {
      let JSX = [];
      if (this.state.products.includes("GMC")) {
        JSX.push(
          <>
            <th>UHID</th>
            <th>Sum Insured</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Refund</th>
            <th>Group Policy Number</th>
            <th>Status</th>
          </>
        );
      }
      if (this.state.products.includes("GPA")) {
        JSX.push(
          <>
            <th>UHID</th>
            <th>Sum Insured</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Refund</th>
            <th>Group Policy Number</th>
            <th>Status</th>
          </>
        );
      }
      if (this.state.products.includes("GTL")) {
        JSX.push(
          <>
            <th>UHID</th>
            <th>Sum Insured</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Refund</th>
            <th>Group Policy Number</th>
            <th>Status</th>
          </>
        );
      }
      return JSX.map((el) => el);
    };
    const generateDependentData = (dependents) => {
      const totalDependents = dependents.length;
      const emptyIterations = Array(7 - totalDependents).fill(0);

      return (
        <>
          {dependents.map((dependent) => (
            <>
              <td>{dependent?.relation}</td>
              <td>{dependent?.first_name}</td>
              <td>{dependent?.last_name}</td>
              <td>{dependent?.dob}</td>
            </>
          ))}
          {emptyIterations.map((_) => (
            <>
              <td> </td>
              <td> </td>
              <td> </td>
              <td> </td>
            </>
          ))}
        </>
      );
    };
    return (
      <table
        style={{ display: "none" }}
        id="excel-to-be-downloaded"
        width="2000px"
      >
        <thead>
          <tr>
            <th colSpan="6"> </th>
            {numbers.map((num) => (
              <th colSpan="4">Dependent {num}</th>
            ))}
            {this.state.products.includes("GMC") && <th colSpan="7">GHI</th>}
            {this.state.products.includes("GPA") && <th colSpan="7">GPA</th>}
            {this.state.products.includes("GTL") && <th colSpan="7">GTL</th>}
          </tr>
          <tr>
            <th>Name</th>
            <th>Gender</th>
            <th>Date Of Birth</th>
            <th>Email</th>
            <th>Mobile</th>
            <th>Dependents</th>
            {generateDependentsHeaders()}
            {generateProductsHeaders()}
          </tr>
        </thead>
        <tbody>
          {this.state.arrForSearch.map((employee) => (
            <tr>
              <td>{employee.name}</td>
              <td>{employee.gender}</td>
              <td>{employee.dob}</td>
              <td>{employee.email}</td>
              <td>{employee.phone}</td>
              <td>{employee.no_of_dependents}</td>
              {generateDependentData(employee.dependents)}
              {this.state.products.includes("GMC") && (
                <>
                  <td>{employee?.GMC?.employee_uhid}</td>
                  <td>{employee?.GMC?.sum_insured}</td>
                  <td>{employee?.GMC?.start_date}</td>
                  <td>{employee?.GMC?.end_date}</td>
                  <td>{employee?.GMC?.refund}</td>
                  <td>{employee?.GMC?.policy_number}</td>
                  <td>
                    {employee?.GMC?.policy_status || "ACTIVATION PENDING"}
                  </td>
                </>
              )}
              {this.state.products.includes("GPA") && (
                <>
                  <td>{employee?.GPA?.employee_uhid}</td>
                  <td>{employee?.GPA?.sum_insured}</td>
                  <td>{employee?.GPA?.start_date}</td>
                  <td>{employee?.GPA?.end_date}</td>
                  <td>{employee?.GPA?.refund}</td>
                  <td>{employee?.GPA?.policy_number}</td>
                  <td>
                    {employee?.GPA?.policy_status || "ACTIVATION PENDING"}
                  </td>
                </>
              )}
              {this.state.products.includes("GTL") && (
                <>
                  <td>{employee?.GTL?.employee_uhid}</td>
                  <td>{employee?.GTL?.sum_insured}</td>
                  <td>{employee?.GTL?.start_date}</td>
                  <td>{employee?.GTL?.end_date}</td>
                  <td>{employee?.GTL?.refund}</td>
                  <td>{employee?.GTL?.policy_number}</td>
                  <td>
                    {employee?.GTL?.policy_status || "ACTIVATION PENDING"}
                  </td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  render() {
    return (
      <>
        {this.state.companyLoader ? (
          <OverlayLoader />
        ) : (
          <>
            <HomeWrapper>
              {this.state.navigateToPreviewEmployeeId && (
                <Navigate
                  to="/e-card-preview"
                  state={{
                    employeeId: this.state.navigateToPreviewEmployeeId,
                    productType: this.state.flexCurrentProductName,
                  }}
                />
              )}
              {((!this.state.employeeLoader && isGmcFlow()) ||
                !this.state.employeeLoader ||
                isFlexFlow()) && (
                <>
                  {this.renderCareBox()}
                  {!this.state.showAnnualGmcFields &&
                    !isFlexFlow() &&
                    this.renderPayDiv()}
                </>
              )}
              {(isGmcFlow() || isFlexFlow()) && <Divider />}

              <>
                {this.state.showPayment && (
                  <PaymentPopup
                    parentCallback={this.handleCallback}
                    paymentValues={this.state.overallsummary || []}
                  ></PaymentPopup>
                )}

                <BoxHeading>
                  <Ptag fontSize="24px" fontWeight="700">
                    Plan Summary
                  </Ptag>
                </BoxHeading>

                {this.renderCard()}
              </>

              {!this.state.employeeLoader && !isGmcFlow() && !isFlexFlow() && (
                <>
                  <Divider />
                  {this.renderCareBox()}
                  {!this.state.showAnnualGmcFields && this.renderPayDiv()}
                </>
              )}

              {isGmcFlow() &&
                this.state.employeeLoader &&
                !this.state.companyLoader && (
                  <LoaderWrapper>
                    <LoaderDots />
                  </LoaderWrapper>
                )}
            </HomeWrapper>

            {!isFlexFlow() && !this.state.employeeLoader && (
              <div
                style={{
                  marginLeft: "248px",
                  backgroundColor: "#dadada",
                  paddingTop: "14px",
                }}
              >
                <HomeWrapper marginLeft="0px">
                  <BoxHeading>
                    <Ptag fontSize="24px" fontWeight="700">
                      Manage Employees
                    </Ptag>
                  </BoxHeading>

                  <SearchfilterDiv>
                    <InputDiv>
                      <input
                        className="input-elevated"
                        onChange={(e) => {
                          this.searchMisTable(e);
                        }}
                        type="text"
                        placeholder="Search Employee"
                      />
                    </InputDiv>
                    <div style={{ display: "flex" }}>
                      <FilterDiv>
                        <FilterImage src={FilterIcon} />
                        <Dropdown onChange={this.filter} color="#fff">
                          <Option value="" default disabled selected hidden>
                            Filter
                          </Option>

                          <Option value={"none"}>{"None"}</Option>

                          {this.state.showFilterArray &&
                            this.state.showFilterArray.map((item, key) => (
                              <Option
                                value={item.toLowerCase()}
                                key={`FilterArray${key}`}
                              >
                                {item}
                              </Option>
                            ))}
                        </Dropdown>
                        <div style={{ marginRight: "12px" }}>
                          <Icons icon={"chevron_down"} fill="#ffffff" />
                        </div>
                      </FilterDiv>
                      <Download onClick={this.downloadExcel}>
                        <img
                          src={DownloadIcon}
                          width="18px"
                          height="18px"
                          style={{ marginRight: 8 }}
                        />
                        <Ptag
                          fontSize="14px"
                          fontWeight="600"
                          color="#FFFFFF"
                          lineHeight="24px"
                          letterSpacing="0.5px"
                        >
                          Download
                        </Ptag>
                      </Download>
                      {(this.state.showAnnualGmcFields || isFlexFlow) && (
                        <Download onClick={this.navigeteToAddDeletPage}>
                          <img
                            src={AddIcon}
                            width="20px"
                            height="16px"
                            style={{ marginRight: 8 }}
                          />
                          <Ptag
                            fontSize="14px"
                            fontWeight="600"
                            color="#FFFFFF"
                            lineHeight="24px"
                            letterSpacing="0.5px"
                          >
                            <span
                              style={{
                                whiteSpace: "nowrap",
                              }}
                            >
                              Add/Delete Employee
                            </span>
                          </Ptag>
                        </Download>
                      )}
                      {!this.state.showAnnualGmcFields && !isFlexFlow() && (
                        <DeleteIconDiv onClick={this.onClickDeletePopUp}>
                          <img src={deleteico} width="24px" height="24px" />
                        </DeleteIconDiv>
                      )}
                    </div>
                  </SearchfilterDiv>
                  {isFlexFlow() && this.flexProductList()}
                  {this.renderMis()}

                  {this.state.showDeletePopUp && (
                    <UploadExcelPopUpDiv
                      onClick={() => this.onDeleteNoSelected()}
                    >
                      <Innerpopup onClick={(e) => e.stopPropagation()}>
                        <SubInnerDiv>
                          <FirstRow>
                            <Ptag fontSize="22px" fontWeight="bold">
                              Are you sure you want to remove following
                              employees?
                            </Ptag>
                          </FirstRow>
                          <SecondSubRow></SecondSubRow>
                          <EmployeeAmountDiv>
                            <AmountDiv style={{ paddingBottom: "10px" }}>
                              <Ptag fontSize="16px" fontWeight="bold">
                                Name of Employee
                              </Ptag>
                              <Ptag fontSize="16px" fontWeight="bold">
                                Amount
                              </Ptag>
                            </AmountDiv>
                            {this.state.policies
                              .filter((item) => item["isChecked"])
                              .map((item, index) => (
                                <AmountDiv>
                                  <Ptag
                                    textTransform="capitalize"
                                    fontSize="14px"
                                  >
                                    {`${index + 1}. ${item["name"]}`}
                                  </Ptag>
                                  <Ptag fontSize="14px">{`₹${formatAmount(
                                    item?.total_amount || 0
                                  )}`}</Ptag>
                                </AmountDiv>
                              ))}
                            <Hr />
                          </EmployeeAmountDiv>

                          <AddExcelbtn>
                            <LargeButton
                              onClick={() => this.onClickDelete()}
                              label="Yes"
                              style={{ padding: "8px 0px", margin: "8px 6px" }}
                            />
                            <LargeButton
                              onClick={() => this.onDeleteNoSelected()}
                              label="No"
                              style={{ padding: "8px 0px", margin: "8px 6px" }}
                            />
                          </AddExcelbtn>
                        </SubInnerDiv>
                      </Innerpopup>
                    </UploadExcelPopUpDiv>
                  )}
                  {/* {this.downloadExcelTable()} */}
                </HomeWrapper>
              </div>
            )}
            {isFlexFlow() && (
              <HomeWrapper style={{ paddingBottom: "20px" }}>
                <BaseTable
                  companyData={this.state.gmcMisData}
                  showTable={this.state.uhidExists}
                />
              </HomeWrapper>
            )}
          </>
        )}
      </>
    );
  }
}
export const MessageDiv = styled.div`
  height: 50vh;
  margin-top: 1.5rem;
  background: rgba(201, 211, 231, 0.214);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// const HomeWrapper = styled.div`
//   margin-left: ${(props) => (props.marginLeft ? props.marginLeft : "248px")};
//   transition: margin-left 0.2s ease-in;
//   padding: 40px;
//   box-sizing: border-box;
//   display: flex;
//   flex-direction: column;
//   background-color: white;
//   box-shadow: rgb(0 0 0 / 15%) 0px 1px 4px 0px;
// `;

const UploadExcelPopUpDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: fixed;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1200;
`;

const Innerpopup = styled.div`
  position: absolute;
  left: 25%;
  right: 25%;
  top: 5%;
  bottom: 5%;
  margin: auto;
`;

const SubInnerDiv = styled.div`
  width: 100%;
  padding: 35px 45px;
  background: #ffffff;
  border-radius: 10px;
`;

const FirstRow = styled.div`
  justify-content: space-between;
  display: flex;
`;

const BoxHeading = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 16px;
  align-items: center;
`;

const AddExcelbtn = styled.div`
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
`;

const SearchfilterDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${(props) => props.theme.cardBackgroundColor};
  width: 100%;
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 24px;
`;
const InputDiv = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 15px;
  border-radius: 8px;
`;

const FilterDiv = styled.div`
  display: flex;
  cursor: pointer;
  justify-content: space-between;
  margin-right: 10px;
  width: 180px;
  height: 43px;
  margin: 0 14px;
  border-radius: 10px;
  font-size: 12px;
  position: relative;
  overflow: hidden;
  z-index: 0;
  & > div {
    position: absolute;
    user-select: none;
    pointer-events: none;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
  }
`;
const DeleteIconDiv = styled.div`
  padding: 7px 5px 3px 5px;
  border-radius: 10px;
  border: solid 1px #436ab2;
  cursor: pointer;
`;
const SecondSubRow = styled.div`
  padding-top: 10px;
`;
const EmployeeAmountDiv = styled.div`
  background: #f3f4f7;
  width: 100%;
  padding: 30px 20px;
  margin-top: 20px;
  border-radius: 10px;
  height: 250px;
  overflow: auto;
`;
const AmountDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 0px;
`;
const Hr = styled.div`
  border: 1px solid #cdc9c9;
  margin: 10px 0px;
`;

const PlanSummaryBox = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: repeat(auto-fit);
  row-gap: 24px;
  padding: 10px 0px 0px 0px;
  grid-gap: 24px;
  column-gap: 18px;
  padding-bottom: 12px;
  overflow: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
  // overflow-x:scroll
  // ::-webkit-scrollbar {
  //     display: none;
  //   }
  //   overflow: -moz-scrollbars-none;
  //   -ms-overflow-style: none;
`;

const TotalEmployees = styled.div`
  border: 2px solid #436ab2;
  padding: 20px 24px;
  border-radius: 8px;
  margin-right: 18px;
  width: 343px;
`;

const SummaryBox = styled.div`
  border: 2px solid #436ab2;
  padding: 15px 10px;
  border-radius: 8px;
  // margin-right:10px;
  width: 100%;
  min-width: 360px;
  min-height: 160px;
`;
const TotalLives = styled(TotalEmployees)``;
const InnerDiv = styled.div`
  display: flex;
`;
const PlanSummaryInnerDiv = styled.div`
  display: flex;
  align-items: start;
  padding-bottom: 30px;
`;
const NumberDiv = styled.div`
  padding-left: 10px;
`;
const PlanSummaryNumberDiv = styled.div`
  padding-left: 5px;
`;

const PayDiv = styled.div`
  display: flex;
  display: -webkit-box;
  text-align: center;
  padding-bottom: 30px;
  background: ${(props) => props.theme.cardBackgroundColor};
  border-radius: 8px;
  padding: 24px 24px;
  // margin: 3px 0px;
  align-items: flex-start;
  margin-top: 20px;
`;

const Subscription = styled.div`
  margin-right: 100px;
`;
const Duedate = styled.div``;

const CommonBox = styled.div`
  display: flex;
`;

const Cashless = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const CareEmployeesBox = styled.div`
  display: flex;
  padding-bottom: 10px;
  padding-top: 4px;
`;

const Download = styled.div`
  margin-top: 0px;
  border: 0px;
  color: rgb(255, 255, 255);
  background: ${(props) => props.theme.accentColor};
  padding: 10px 20px;
  display: flex;
  padding: 1.2rem 2rem;
  justify-content: space-between;
  align-items: center;
  letter-spacing: 0.5px;
  font-size: 0px;
  cursor: pointer;
  letter-spacing: 0.5px;
  height: 44px;
  border-radius: 10px;
  margin-right: 10px;
  transition: 0.2s ease-in-out all;
`;

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 44px;
`;

const Dropdown = styled.select`
  display: flex;
  position: relative;
  width: 100%;
  border: none;
  font-family: "Inter";
  font-size: 14px;
  padding: 10px 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.25px;
  padding-left: 36px;
  color: ${(props) => (props.color ? props.color : "rgba(0, 0, 0, 0.5)")};
  background-color: ${(props) => props.theme.accentColor};
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  &:hover,
  &:focus {
    outline: 0 !important;
  }
`;

const Option = styled.option`
  color: ${(props) => (props.color ? props.color : "black")};
`;

const PricePart = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 4px;
  align-items: baseline;
  & > :first-child {
    margin-right: 8px;
  }
`;

const Links = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CardHeaderRight = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 100px;
`;

const RenewTag = styled.div`
  text-decoration: line-through;
  font-family: "Inter";
  text-align: right;
  line-height: normal;
  margin: 0px;
  text-transform: none;
  opacity: 1;
`;

const TextTag = styled.div`
  font-family: "Inter";
  font-style: normal;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  text-align: left;
  letter-spacing: 0.555556px;
`;

const AmountTag = styled.div`
  display: inline-flex;
  flex-direction: row;
`;

const AnnualRow = styled.div`
  font-weight: bold;
`;

const FilterImage = styled.img`
  position: absolute;
  height: 14px;
  top: 14px;
  left: 14px;
  z-index: 999;
  user-select: none;
  pointer-events: none;
`;

// const ListRow = styled.liststyle`
//   background: ${props => props=== 'STOPPED' ?}
//   /* liststyle.policy_status === 'STOPPED' ? { background: rgba(242,158,158) } : !(index % 2) ? { background: #fff, height: 48 } : { background: "#D0D9E9", height: 48, }; */
// `

export default CaredashboardList;
